import clsx from "clsx";

type Props = {
  title?: string;
  className?: string;   // можно передать свои размеры/обрезку (например, w-full aspect-[4/3])
};

export default function MissingImage({ title = "Нет изображения", className }: Props) {
  const label = title ? `Нет изображения: ${title}` : "Нет изображения";
  return (
    <div
      aria-label={label}
      className={clsx(
        // базовый стиль «заглушки»
        "placeholder-grid w-full flex flex-col items-center justify-center select-none",
        "bg-gradient-to-br from-indigo-500/20 via-purple-600/10 to-fuchsia-500/10",
        "text-white/70 backdrop-blur-sm border-t border-white/10 rounded-b-none",
        // по умолчанию даём разумное соотношение сторон…
        "aspect-[4/3]",
        // …и позволяем это переопределять извне через пропс
        className
      )}
    >
      {/* иконка */}
      <svg width="44" height="44" viewBox="0 0 24 24" className="opacity-90 mb-2">
        <path fill="currentColor" d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14l4-4l2 2l5-5l7 7ZM8.5 11A2.5 2.5 0 1 1 6 8.5A2.5 2.5 0 0 1 8.5 11Z"/>
      </svg>

      {/* подпись */}
      <div className="text-[13px] font-medium">Изображение недоступно</div>
      {title && (
        <div className="mt-1 max-w-[90%] text-center text-[12px] text-white/50 line-clamp-1">
          {title}
        </div>
      )}
    </div>
  );
}
